import React from 'react'
import { Typography } from '@mui/material';
import NeswList1 from './NewsList1';


const Tech = () => {
  return (
    <>
        <Typography variant='h2' align='center' color="textPrimary" gutterBottom marginTop="0.5em">Tech News</Typography>

          <NeswList1/>


    </>
  )
}

export default Tech